import { Scope1DesiredData } from 'models/ActivityDataScope1DesiredData/scope1DesiredData.model';
import { atleastOneRequired } from 'constants/constants';
import { ScopeData } from 'models/ActivityDataEntryScopes/scopes.model';
import { FormikProps } from 'formik';

interface Scope1ErrorMessages {
    stationaryCombustion: { fuelValue: string }[];
    mobileSources: { fuelValue: string }[];
    processSources: { fuelValue: string }[];
    fugitiveEmissions: { fuelValue: string }[];
}

export const customValidate = (
    values: Scope1DesiredData
): Scope1ErrorMessages | {} => {
    const sources: Array<keyof Scope1ErrorMessages> = [
        'stationaryCombustion',
        'fugitiveEmissions',
        'processSources',
        'mobileSources',
    ];

    // Initialize errors with empty fuelValue fields for each source
    let errors: Scope1ErrorMessages = sources.reduce((acc, source) => {
        acc[source] = values[source]?.map(() => ({ fuelValue: '' })) ?? [];
        return acc;
    }, {} as Scope1ErrorMessages);

    // Check if all fuelValue fields are null for every source
    const hasFuelValue = sources.some(source =>
        values[source]?.some(({ fuelValue }) => fuelValue !== null)
    );

    // If no fuelValue is filled, mark all fuelValue fields with an error
    if (!hasFuelValue) {
        sources.forEach(source => {
            values[source]?.forEach((_, index) => {
                errors[source][index].fuelValue = atleastOneRequired;
            });
        });
        return errors;
    }

    return {};
};

export const handleAlertSubmit = (
    formikRef: React.RefObject<FormikProps<Scope1DesiredData>> | undefined,
    selectedSource: string,
    switchMonthlyItem: ScopeData | undefined,
    selectedItemIndex: number | undefined,
    selectedSourceIndex: string,
    setIsSwitchMonthly: React.Dispatch<React.SetStateAction<boolean>>,
    setIsSwitchMonthlyAlert: React.Dispatch<React.SetStateAction<boolean>>,
    setInitialMonthlyValues: React.Dispatch<React.SetStateAction<ScopeData>>
) => {
    const values = formikRef?.current?.values;
    const sourceItem = values?.[selectedSource as keyof Scope1DesiredData];
    const selectedItem = sourceItem?.filter(
        (item) => switchMonthlyItem?.id === item?.id
    );

    let resultedValue;
    if (selectedItem && selectedItem?.length > 1) {
        const refrigerantItem = sourceItem?.filter(
            (_: unknown, index: number | undefined) => index === selectedItemIndex
        );
        resultedValue = refrigerantItem?.[0];
    } else {
        resultedValue = selectedItem?.[0];
    }

    if (resultedValue?.isYearly) {
        setIsSwitchMonthly(true);
    } else {
        const desiredInitialValues = {
            ...resultedValue,
            isYearly: !resultedValue?.isYearly,
            fuelValue: null,
            scopeMonthlyData: undefined,
        };
        setInitialMonthlyValues(desiredInitialValues);
        formikRef?.current?.setFieldValue(`${selectedSourceIndex}`, desiredInitialValues);
    }

    setIsSwitchMonthlyAlert(false);
};